import { render, staticRenderFns } from "./reserveParamsManageList.vue?vue&type=template&id=f8bfdc4e&scoped=true"
import script from "./reserveParamsManageList.vue?vue&type=script&lang=js"
export * from "./reserveParamsManageList.vue?vue&type=script&lang=js"
import style0 from "./reserveParamsManageList.vue?vue&type=style&index=0&id=f8bfdc4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bfdc4e",
  null
  
)

export default component.exports